import React, { useEffect, useState } from "react";
import GlobelStore from "../../../Store/GlobelStore";
import Icon from "../../../components/Icons/Icon";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import AgencyStore from "../../../Store/AgencyStore";

const Notification = observer(() => {
  const [notificationData, setNotificationData] = useState([]);
  const navigate = useNavigate();

  const handleViewAll = () => {
    navigate("/agency/notification");
    AgencyStore.setSelectedMenuItem("Notification");
  };

  useEffect(() => {
    const data = GlobelStore?.dashboardAllData?.notificationsData;
    if (data) {
      setNotificationData(data);
    }
  }, [GlobelStore?.dashboardAllData?.notificationsData]);

  return (
    <div className="notificationContainer">
      <div className="titleContainer">
        <div className="title">Notifications</div>
        <div className="underlineClick" onClick={() => handleViewAll()}>
          View All
        </div>
      </div>

      {notificationData.length === 0 ? (
        <div className="noRecordsMessage">No records available</div>
      ) : (
        notificationData.map((item, index) => (
          <div className="notificationHeaderContainer" key={index}>
            <div className="gridItem notificationItem">
              <Icon iconName="message" className="notificationIcon" />
              {item?.notificationTitle}
            </div>
            <div className="gridItem  notificationItem flexLeft">
              {item?.type}
            </div>
          </div>
        ))
      )}
    </div>
  );
});

export default React.memo(Notification);
